module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-type-collab-bank-9dd0d1de6a9a2714801a927e9769e2d8.svg";